// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"48d8805a","884":"ccf58126"}[chunkId] + ".chunk.js";
};